/** @module csi/skintheme/DragonFruit */
define([], function() {
	return {
		Blue1: "Blue30",
		Blue2: "Blue50",
		Blue3: "Magenta400",

		PrimaryBlue: "Magenta600",
		PrimaryDisabledColor: "Magenta100",
		PrimaryColor2: "Magenta700",
		PrimaryColor3: "Magengta800",

		SiteHeaderBackground: "Grey50",

		CompanyHeaderBlue1: "Grey50",
		CompanyHeaderBlue2: "Grey200",

		/* LINK */
		LinkNormal: "Blue600",
		LinkHover: "Blue800",
		LinkActive: "Blue600",

		/* Comment */
		CommentActiveColor: "Blue600",

		/** custom view */
		CustomViewOptionActiveColor: "Blue500",

		/* FULL SCREEN HEADER */
		FullScreenHeaderBackgroundColor: "Grey50",
		FullScreenLogoBackgroundColor: "Grey50",

		/* TEXT */
		TabsTextActive: "Magenta600",

		/* Button */
		BtnPrimaryFocusedBorderColor: "Magenta900",
		ButtonSwitchNormalIconStateOnBackgroundColor: "Magenta600",

		/* BreadCrumb */
		BreadcrumbNormalLinkColor: "Blue600",

		/* CheckBox */
		CheckBoxFocusColor: "Blue300",

		/* Text Border */
		TextfieldActiveBorderColor: "Black200",
		BtnToolbarFocusedBorderColor: "Black200",

		/* DropDown */
		DropdownSelectActiveBorderColor: "Black200",

		/* Header */
		LastVisitedIconColor: "Grey50",
		LastVisitedBackgroundColor: "Black400",
		PageHeaderButtonTextColor: "SecondaryText",
		PageHeaderToolbarIconColor: "Black400",
		PageHeaderToolbarHoverColor: "Magenta600",
		PageHeaderSearchInButtonHoverColor: "Grey100",
		PageHeaderToolbarSeparatorColor: "Grey300",
		PageHeaderSearchScopeBackgroundColor: "White50",
		PageHeaderSearchBlockBackgroundColor: "Grey300",
		CompanyLogoTextColor: "Black50",
		CompanyLogoImageURL: "LightCompanyLogoIconURL",
		ExitFullScreenIconURL: "LightExitFullScreenIconURL",

		/* Table */
		TableCopyBorderColor: "Blue600",
		TablePasteBorderColor: "Blue600",
		TableNewRowBackgroundColor: "Blue100",

		/* Slicer */
		SlicerMetricsBackgroundColor: "Magenta100",

		/* Chart */
		ChartAreaURL: "ChartAreaMagentaURL",
		ChartBarURL: "ChartBarMagentaURL",
		ChartColumnURL: "ChartColumnMagentaURL",
		ChartDoughnutURL: "ChartDoughnutMagentaURL",
		ChartLineURL: "ChartLineMagentaURL",
		ChartMsAreaURL: "ChartMsAreaMagentaURL",
		ChartMsBarURL: "ChartMsBarMagentaURL",
		ChartMsColumnURL: "ChartMsColumnMagentaURL",
		ChartMsLineURL: "ChartMsLineMagentaURL",
		ChartParetoURL: "ChartParetoMagentaURL",
		ChartPieURL: "ChartPieMagentaURL",
		ChartStackedAreaURL: "ChartStackedAreaMagentaURL",
		ChartStackedBarURL: "ChartStackedBarMagentaURL",
		ChartStackedColumnURL: "ChartStackedColumnMagentaURL",

		/* Progress bar */
		ProgressBarDeterminateProgressColor: "PrimaryColor",

		HighlightSelected: "Grey200"
	};
});